<template>
  <div>
    <div v-show="show1" class="heightPage cardIndex">
      <cardIndex
        :BankList="BankList"
        :ysList="ysList"
        :processList="processList"
        @confirmingBank="confirmingBank"
        @manage="manage"
        :type="2"
      >
        <template v-slot:steps>
          <el-steps
            simple
            style="width: 90%; margin: 0 auto; margin-top: 30px"
            class="mySteps"
            :active="7"
          >
            <el-step title="选择银行" icon="">
              <template slot="icon">
                <span>1</span>
              </template>
            </el-step>
            <el-step title="完善信息">
              <template slot="icon">2</template>
            </el-step>
            <el-step title="通知银行">
              <template slot="icon">3</template>
            </el-step>
            <el-step title="银行预约上门">
              <template slot="icon">4</template>
            </el-step>
            <el-step title="依规开立成功">
              <template slot="icon">5</template>
            </el-step>
          </el-steps>
        </template>
      </cardIndex>
    </div>

    <transition name="el-zoom-in-bottom">
      <CardList v-if="show2" @noteCard="noteCard" />
    </transition>
    <transition name="el-zoom-in-bottom">
      <businessDescriptionPage
        v-if="show3"
        @noteCard="noteCard"
        :bankInfoList="bankInfoList"
      />
    </transition>
  </div>
</template>
<script>
import cardIndex from "../../components/cardIndex.vue";
import CardList from "./CardList";
import businessDescriptionPage from "./businessDescriptionPage";
import { verifyPermissionMinix } from "@/utils/mixin";

export default {
  components: {
    cardIndex,
    CardList,
    businessDescriptionPage,
  },
  mixins: [verifyPermissionMinix],
  data() {
    return {
      operation: "",
      processList: [
        { num: "01", content: "选择银行" },
        { num: "02", content: "完善信息" },
        { num: "03", content: "通知银行" },
        { num: "04", content: "银行预约上门" },
        { num: "05", content: "依规开立成功" },
      ],
      ysList: [
        {
          num: 1,
          title: "全程零费用：",
          content: "无论是工本费还是U盾费还是回单箱费用全免。",
        },
        {
          num: 2,
          title: "银行上门服务：",
          content: "在系统内提交后，由广发银行工作人员提供上门服务。",
        },
        {
          num: 3,
          title: "转账优惠：",
          content: "优惠期内跨行转账，公转私转账费用全免。",
        },
        {
          num: 4,
          title: "惠企补贴：",
          content: "由瑞启依据对账规则为您提供额外补贴。",
        },
      ],
      addCustomerDrawerShow: false,
      drawerTitle: "",
      noticeDialogVisible: false,
      fileVisible: false,
      selectVisible: false,
      form: {},
      submitLoading: false,
      rules: {},
      talentList: [],
      tipVisible: false,
      checked: false,
      checkList: {},
      checked1: false,
      checked2: false,
      checked3: false,
      show1: true,
      show2: false,
      show3: false,
      bankInfoList: [],
      BankList: [],
      loading: false,
    };
  },
  mounted() {
    this.getBankList();
  },
  methods: {
    manage() {
      this.show2 = !this.show2;
      this.show1 = !this.show1;
    },
    confirmingBank(bankInfoList) {
      this.show1 = !this.show1;
      this.show3 = !this.show3;
      this.bankInfoList = bankInfoList;
      // this.$router.push(
      //   "/businessDescriptionPage?list=" + JSON.stringify(this.bankInfoList)
      // );
    },
    getBankList() {
      this.loading = true;
      this.$api.manage.CorporateAccountBusiness().then((res) => {
        if (res.error === false) {
          this.BankList = res.data;
          this.BankList.forEach((item) => {
            this.$set(item, "check", false);
          });
          this.loading = false;
        } else {
          this.loading = false;

          this.$message.error(res.msg);
        }
      });
    },
    confirm() {
      this.show2 = !this.show2;
      this.show1 = !this.show1;
    },
    noteCard() {
      this.show2 = !this.show2;
      this.show1 = !this.show1;
    },
    myselect(item) {
      if (this.type != 1) {
        if (item.check == true) {
          this.$set(item, "check", !item.check);
          this.bankInfoList = [];
        } else {
          this.BankList.forEach((item) => {
            item.check = false;
          });
          this.$set(item, "check", !item.check);
          this.bankInfoList = [];
        }

        this.BankList.forEach((item) => {
          if (item.check) {
            this.bankInfoList.push({
              bankId: item.bankId,
              bankName: item.bankName,
              sendCC: item.ccEmail,
              sendTo: item.email,
              bankUniqueFlag: item.uniqueFlag,
            });
          }
        });
        this.$forceUpdate();
      } else {
        this.$set(item, "check", !item.check);
        this.bankInfoList = [];
        this.BankList.forEach((item) => {
          if (item.check) {
            this.forBank(item);
          }
        });
        this.$forceUpdate();
      }
    },
    forBank(item) {
      this.bankInfoList.push({
        bankId: item.bankId,
        bankName: item.bankName,
        autoIntId: item.autoIntId,
        bankAutoIntId: item.bankAutoIntId,
        userAutoIntId: this.userAutoIntId,
        bankBusinessId: item.id,
        CompanyAutoIntId: this.CompanyAutoIntId,
        bankUniqueFlag: item.uniqueFlag,
      });
    },
    addbank(item) {
      if (this.type != 1) {
        if (item.check == true) {
          // this.$set(item, "check", !item.check);
          this.bankInfoList = [];
        } else {
          this.BankList.forEach((item) => {
            item.check = false;
          });
          // this.$set(item, "check", !item.check);
          this.bankInfoList = [];
        }
        // this.bankInfoList = [];

        this.BankList.forEach((item) => {
          if (item.check) {
            this.bankInfoList.push({
              bankId: item.bankId,
              bankName: item.bankName,
              sendCC: item.ccEmail,
              sendTo: item.email,
              bankUniqueFlag: item.uniqueFlag,
            });
          }
        });
      } else {
        this.bankInfoList = [];
        this.BankList.forEach((item) => {
          if (item.check) {
            this.forBank(item);
          }
        });
      }
    },
    singleNot() {
      this.fileVisible = true;
      // this.importVisible = true;
    },
    addPersonnel() {
      if (this.bankInfoList.length <= 0) {
        this.$message.error("请选择银行");
        return;
      }
      this.operation = "add";
      this.addCustomerDrawerShow = true;
      this.drawerTitle = "新增人员开卡";
    },
    resetForm() {},
    notifyCard() {
      if (this.bankInfoList.length <= 0) {
        this.$message.error("请选择银行");
        return;
      }
      this.noticeDialogVisible = true;
    },
  },
};
</script>
<style>
.checkbox {
  zoom: 200%;
}
</style>
<style lang="less" scoped>
.tip {
  h2 {
    font-weight: normal;
  }
  .ys_Title {
    font-weight: 700;
    color: #1683f5;
  }
  width: 1025px;
  margin: 0 auto;
  margin-top: 10px;
  padding: 10px;
  font-size: 12px;
  // color: #e6a23c;
  p {
    margin-top: 10px;
  }
}
.title {
  font-size: 30px;
  // text-align: center;
  color: #333333;
  font-weight: normal;
}
.btnContainer {
  width: 100%;
  text-align: center;
  position: relative;
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.bankContainer .bank img {
  width: 330px;
  height: auto;
  margin: 0 10px;
  border: 1px solid rgba(204, 204, 204, 0.443);
}
.bankContainer {
  margin-top: 10px;
  .bank {
    width: 500px;
    margin-top: 10px;
    img {
      display: block;
      margin: 0 auto;
    }
  }
  .span {
    display: flex;
    justify-content: right;
    font-size: 12px;
    margin-top: 10px;
    a {
      text-decoration: underline;
      margin-left: 10px;
      color: inherit;
    }
    a:hover {
      color: #409eff;
    }
  }
}
.bankContainer .bank .content .bankCont {
  height: auto;
  -webkit-line-clamp: 5;
}
</style>